import { formatDateTime } from "@/shared/lib/i18n/formatters.ts";

/**
 * Format date string to a readable format in the active language.
 */
export const formatDate = (dateString: string): string => {
  return formatDateTime(new Date(dateString));
};

/**
 * Check if a date is within the last N days
 */
export const isWithinLastDays = (dateString: string, days: number): boolean => {
  const date = new Date(dateString);
  const cutoffDate = new Date(Date.now() - days * 24 * 60 * 60 * 1000);
  return date > cutoffDate;
};
